



















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';

@Component
export default class GoogleContactList extends Vue {
  @Prop() searchContact;
  @Prop() selectedGoogleContacts;
  get googleContacts() {
    return vxm.referrals.GoogleContactResponse.contacts;
  }
  get filteredGoogleContacts() {
    if (!this.searchContact) {
      return this.googleContacts;
    }
    return this.googleContacts.filter((contact) => {
      return (
        (contact.fullName &&
          contact.fullName
            .toLowerCase()
            .indexOf(this.searchContact.toLowerCase()) !== -1) ||
        (contact.email &&
          contact.email
            .toLowerCase()
            .indexOf(this.searchContact.toLowerCase()) !== -1)
      );
    });
  }
  isSelected(gc): boolean {
    const idx = this.selectedGoogleContacts.findIndex((i) => {
      return i.fullName === gc.fullName && i.email === gc.email;
    });
    if (idx === -1) {
      return false;
    } else {
      return true;
    }
  }
}
